import { cookieKeys } from "../config/cookies.js";
import { getCookie, setCookie } from "./cookies.js";
import $ from 'jquery';

export const getLocalCurrency = function() {
	var regionCode = getRegionCode();
	var currency = "USD"; 
	if(regionCode == "GB"){
		currency = "GBP"; 
	}
	return currency;
}

function getRegionCode() {
	const region = getCookie(cookieKeys.region);

	if (region == '') {
		return 'US'; // default locale
	}

	return region;
}

const $regionDropdown = $('#tel-dropdown');
const $regionDropdownMenu = $('#tel-dropdown-menu');

if ($regionDropdown.data('country-code') != getRegionCode()) {
	// Happens when page loads before cURL to retrieve country code is complete
	const correctRegionText = $regionDropdownMenu.find(`.region-selector[data-region="${getRegionCode()}"]`).html();
	$regionDropdown.html(correctRegionText);
}

$regionDropdownMenu.find('.region-selector').each(function() {
	const region = $(this).data('region');

	// cleanup excess region selector
	if (region == getRegionCode()) {
		$(this).hide();
	}

	$(this).on('click', function() {
		setCookie(cookieKeys.region, region, 30);
		location.reload();
	});
});


// WEBPACK FOOTER //
// /data/web/app/themes/epv/bs-embeds/src/helpers/currency.js